import * as _ from "lodash";
import { Observer, Observable, Subscriber } from "rxjs";
export class AnimationHelper {
    numFrames: number;
    numIntervals: number;
    constructor(public duration: number,
                public fps = 60) 
    {
        this.numFrames = (this.duration / 1000) * this.fps;
        this.numIntervals = this.numFrames - 1;
    }

     private increment(v_initial: number, 
                        v_final: number): number 
     {
         let distance = v_final - v_initial;
         let rv: number[] = [];
         let increment = distance / this.numIntervals;
         return increment;
     }

     // An rx that publishes no values and signals completion on its observer after ms±50 milliseconds.
     // It differs from a naive delay in that the timer doesn't tick while pauseSignal is true.
    pausableDelay(paused: Observable<boolean> | undefined, ms: number): Observable<any> {
         return Observable.create((obs: Observer<any>) => {
            let i = 0;
            let ticker = Observable.interval(50).map(() => i+=50);

            let inner = new Subscriber(undefined, undefined, () => obs.complete());
            let paus = paused ? paused : Observable.of(false);
            return paus.switchMap(paused => paused ? Observable.never() : ticker)
                .takeWhile(val => val <= ms)
                .subscribe(inner);
         });
    }

    pausableInterval(paused: Observable<boolean>): Observable<number> {
        return Observable.create((obs: Observer<number>) => {
            let i = 0;
            let ticker = Observable.interval(1000 / this.fps).map(() => i++)

            let p = paused.switchMap(paused => paused ? Observable.never() : ticker);
            return p.subscribe(val => obs.next(val), err => obs.error(err), () => obs.complete());
         });
     }

     clock(repeat?: boolean, repeatDelay?: number, pauseSignal?: Observable<boolean>): Observable<number> {
        let int = pauseSignal ? this.pausableInterval(pauseSignal) : Observable.interval(1000 / this.fps);

        let rx = int
            .map(i => i + 1)
            .startWith(0)
            .takeWhile(i => i < this.numFrames);
        
        if (repeat) {
            if (typeof repeatDelay !== 'undefined') {
                rx = rx.concat(this.pausableDelay(pauseSignal, repeatDelay));
            }
            rx = rx.repeat(-1);
        }
        return rx;
     }

     tickThrough(clock: Observable<number>, start: number, increment: number): Observable<number> {
         let v = clock.zip(Observable.from(["a, b, c"])).map(v => v[1]);
         return clock.map(t => start + (t * increment));
     }

     static simpleTicker<T>(start: number, end: number, duration: number, repeat?: boolean, repeatDelay?: number, pauseSignal?: Observable<boolean>, fps = 60) {
        let ah = new AnimationHelper(duration, fps);
        return ah.simpleTicker(start, end, repeat, repeatDelay, pauseSignal)
     }

     // pauseSignal is ordinarily going to be an Rx.BehaviorSubject<boolean>
     // that the caller constructs and retains to pause and resume the clock at will.
     // @param start: the number that we start with
     // @param end: the number that we end with
     // Right now, only linear easing is supported.
     simpleTicker<T>(start: number, end: number, repeat?: boolean, repeatDelay?: number, pauseSignal?: Observable<boolean>) {
        let clock = this.clock(repeat, repeatDelay, pauseSignal);
        let inc = this.increment(start, end);
        return this.tickThrough(clock, start, inc);
     }
}


// WEBPACK FOOTER //
// ./src/code/UI/AnimationHelper.ts